/**
 * Runs an initializer when the DOM is ready and again after every Turbo visit.
 *
 * During the migration off rails-ujs (#35411), Turbo Drive is enabled globally
 * but pages opt out with data-turbo="false" until migrated. On those pages
 * navigation is a full reload, so DOMContentLoaded fires as before. On migrated
 * pages Turbo swaps the <body> and fires turbo:load instead. Binding both, and
 * deduping by the current <body> element, runs the initializer exactly once per
 * rendered page in either mode (and does not depend on whether turbo:load fires
 * on opted-out pages).
 *
 * Whole-page renders only: this deliberately does NOT run on turbo:frame-load (a
 * <turbo-frame> swapping its own content). The <body> is unchanged there, and
 * re-running a whole-page initializer would double-bind handlers outside the
 * frame. Content loaded into a frame that needs initialising should listen for
 * turbo:frame-load itself, scoped to that frame; nothing does today.
 *
 * @param {() => void} callback initializer to run for each rendered page
 * @returns {void}
 */
export default function onReady(callback) {
  let ranForBody = null;

  const run = () => {
    if (ranForBody === document.body) return;

    ranForBody = document.body;
    callback();
  };

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', run);
  else
    run();

  document.addEventListener('turbo:load', run);
}
